import React, { Component, Fragment } from "react";
import {
  DevelopmentServices,
  CustomerServices,
  StyleServices
} from "../../../services";
import Async from "react-select";

//field
import Field from "../../Common/Field/Field";

class FabricMainSection extends Component {
  state = {
    selected: "market",
    suppliers: [],
    fabricInfo: {},
    development: "",
    styleList: [],
    buyerPrimarySourceInfo: [],
    bNumberInfo: [],
    supplierInfo: [],
    customerList: [],
    // bnumberValue : {},
    // styleValue : {},
    supplierNameValue: "",
    disabled: this.props.disabled,
    priorityOptions: [],
    dropDown1:[],
  };    

  async componentDidMount() {
    //customer
    await this.getCustomerList();
    //getStyles
    await this.getStyleInfo("");
    await this.getStyleInfoById(this.props.fabric.magnumStyleId);
    await this.getBnoDropdown("");
    await this.getBNumber("");
    //get fabric section from system
    await DevelopmentServices.prefillFabricDetails()
      .then(response => {        
        this.setState({
          fabricInfo: response.data.Fabric,
          embroideryInfo: response.data.Embroidery
        });
      })
      .catch(error => {
        this.props.getalertMessage(
          "error",
          error.toString
        );
      });

    const priorityOptions = [];

    let i = 1;
    while (i <= 10) {
      priorityOptions.push({
        value: i,
        label: i
      });
      i++;
    }
    await this.setState({ priorityOptions });
  }

  handleBaseNoDropdownChange = (inputValue, selectedBaseNo) => {
    // If there is input, fetch dropdown options
    if (inputValue) {
      this.props.getSelectData(
        inputValue,
        selectedBaseNo
      );
    }
  
    // If there is a selected Base No, fetch additional data based on the selection
    if (!selectedBaseNo) {
      this.props.updateFabricData({
        classificationOfFabric: "",
        quality: "",
        composition: "",
        count: { warp: "", weft: "" },
        construction: { warp: "", weft: "" }
      });
    } else {
      // If a valid base number is selected, call the getBNumber function
      this.getBNumber(selectedBaseNo);
    }
  };
  
  // Existing function to fetch Base No dropdown options
  getBnoDropdown = (value) => {
    if (value !== null) {
      DevelopmentServices.getBnoDropdown(value)
        .then((response) => {
          //console.log(response, "responsebno");
          if (response.status === 200) {
            const jsonData = response.data.bNumbers.map((info) => ({
              label: info.label, // Base No label
              value: info.value, // Base No ID
            }));
            this.setState({
              dropDown1: [...jsonData],  // Storing the search results in state
            });
          }
        })
        .catch((error) =>
          this.props.getalertMessage("error", error.toString())
        );
    }
  };
  
  // Existing function to handle when a Base No is selected
  getBNumber = (selectedBaseNo) => {
    if (selectedBaseNo) {
      DevelopmentServices.getBNumber(selectedBaseNo.value)
        .then((response) => {
          if (response.status === 200) {
            // Update fabric data with the new response
           
          let count = {};
          let construction = {};

          // Check and set values if response.data.fabricValues exists
          if (response.text && response.text.data && response.text.data.fabricValues) {
            count = {
              warp: response.text.data.fabricValues.count.warp || 0,
              weft: response.text.data.fabricValues.count.weft || 0,
            };

            construction = {
              warp: response.text.data.fabricValues.construction.warp || 0,
              weft: response.text.data.fabricValues.construction.weft || 0,
            };
          }

            this.props.updateFabricData({
              classificationOfFabric: response.text.data.fabricValues.classificationOfFabric || "",
              quality: response.text.data.fabricValues.quality || "",
              composition: response.text.data.fabricValues.composition || "",
              // requirement: response.data.requirement,
              // countConstruction: response.data.countConstruction,
              // pick: response.data.pick,
              // reed: response.data.reed,
               count:response.text.data.fabricValues.count,
               construction:response.text.data.fabricValues.construction
            });
          }
        })
        .catch((error) => {
          this.props.getalertMessage("error", error.toString());
        });
    }
  };


  


  getCustomerList = () => {
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState({
            customerList: [...response.text.data]
          });
        }
      })
      .catch(error => {
        this.props.getalertMessage(
          "error",
          error.toString
        );
      });
  };

  getStyleInfo = value => {
    if (value !== null) {
      DevelopmentServices.getMagnumStyleNoWithReference(
        value
      )
        .then(response => {
          if (response.status === 200) {
            let jsonData = [];
            response.text.data.map(
              (info, index) => {
                let objData = {};
                objData.label =
                  info.referenceCode;
                objData.value = info.referenceId;
                jsonData.push(objData);
              }
            );
            this.setState({
              styleList: [
                // ...this.state.styleList,
                ...jsonData
              ]
            });
          }
        })
        .catch(error =>
          this.props.getalertMessage(
            "error",
            error.toString()
          )
        );
    }
  };

  getStyleInfoById = id => {
    if (id !== null) {
      DevelopmentServices.getMagnumStyleNoWithReferenceById(
        id
      )
        .then(response => {
          if (response.status === 200) {
            let styleList = [
              ...this.state.styleList,
              ...response.text.data
            ];
            this.setState({ styleList });
          }
        })
        .catch(error =>
          this.props.getalertMessage(
            "error",
            error.toString()
          )
        );
    }
  };

  //supplier
  getSupplierInfo = e => {
    if (e.length > 0) {
      StyleServices.SearchStyle(e)
        .then(response => {
          if (response.status === 200) {
            this.setState({
              supplierInfo: response.text.data
            });
          }
        })
        .catch(error => { });
    }
  };

  changeSupplierInfo = supplierNameValue => {
    supplierNameValue !== null
      ? this.setState(
        { supplierNameValue },
        () => { }
      )
      : this.setState(
        { supplierNameValue: "" },
        () => {
          this.props.getSelectData(
            "supplierName",
            null
          );
        }
      );
  };

  clearValue = () => { };

  render() {
    const {
      buyerPrimarySourceInfo,
      bNumberInfo,
      customerList,
      styleList,
      bnumberValue,
      supplierInfo,
      supplierNameValue,
      priorityOptions,
      dropDown1
    } = this.state;

    const {
      fabric,
      fabricInfo,
      suppliers
    } = this.props;

    const statusOptions = [
      { value: "pending", label: "Pending" },
      { value: "completed", label: "Completed" },
      { value: "cancelled", label: "Cancelled" }
    ];

    let countConstruction = "";
    countConstruction += fabric.count.warp;
    fabric.count.weft !== "" &&
      (countConstruction +=
        " * " + fabric.count.weft);
    fabric.construction.warp !== "" &&
      (countConstruction +=
        " / " + fabric.construction.warp);
    fabric.construction.weft !== "" &&
      (countConstruction +=
        " * " + fabric.construction.weft);

    return (
      <Fragment>
        <div className="mul-check check-padding pl-3">
          <div className="">
            <span className="radio-inline nopadding">
              <input
                name="fabricDevRadio"
                type="radio"
                className="filled-in hide-all"
                id="rad1"
                value="market"
                checked={
                  fabric.selectedType === "market"
                }
                onChange={e =>
                  this.props.updateSelectedRadio(
                    e.target.value
                  )
                }
              />
              <label for="rad1">
                Market/Supplier
                             </label>
            </span>
            <span className="radio-inline">
              <input
                name="fabricDevRadio"
                type="radio"
                className="filled-in hide-all"
                id="rad2"
                value="development"
                checked={
                  fabric.selectedType ===
                  "development"
                }
                onChange={e => {
                  this.props.updateSelectedRadio(
                    e.target.value
                  ),
                    this.props.getDevRefNo();
                }}
              />
              <label for="rad2">
                Development
                             </label>
            </span>
          </div>
        </div>
        <div class="col-xs-5 nopadding">
          <div class="ib-list-view listFieldWrapper nopadding">
            <ul class="main-list">
              <li>
                <ul>
                  <li className="text-right">
                    Supplier Name{" "}
                  </li>
                  <li>
                    <Async
                      name="supplierName"
                      value={fabric.supplierName}
                      onInputChange={
                        this.getSupplierInfo
                      }
                      onChange={supplierNameValue =>
                        this.props.getSelectData(
                          "supplierName",
                          supplierNameValue
                        )
                      }
                      placeholder="Find Suppliername"
                      options={
                        fabricInfo.SUPPLIERNAME
                      }
                      disabled={
                        this.state.disabled
                      }
                      isClearable
                      clearValue={this.clearValue}
                    />
                  </li>
                </ul>
              </li>
              {fabric.selectedType ===
                "development" ? (
                  <li>
                    <ul>
                      <Fragment>
                        <li className="text-right">
                          Request Date
                                     </li>
                        <li>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            value={
                              fabric.requestDate
                                ? fabric.requestDate
                                : ""
                            }
                            inputName="requestDate"
                            onChange={
                              this.props
                                .getFabricData
                            }
                            disabled={
                              this.state.disabled
                            }
                          />
                        </li>
                      </Fragment>
                    </ul>
                  </li>
                ) : (
                  <li className="height-27" />
                )}
              <li>
                <ul>
                  <li className="text-right">
                    Status{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="status"
                      value={fabric.status}
                      options={statusOptions}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li className="print-hidden">
                <ul>
                  <li className="padding-for-li">
                    Count
                                 </li>
                </ul>
              </li>
              <li className="print-hidden">
                <ul>
                  <li className="text-right">
                    Warp<span>:</span>{" "}
                  </li>
                  <li>
                    <input
                      type="text"
                      className="form-control width-150"
                      name="warp"
                      tabIndex="1"
                      value={fabric.count.warp}
                      onChange={e =>
                        this.props.updateCountConstruction(
                          e,
                          "count"
                        )
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                  <li className="text-right">
                    <b>Weft</b>
                    <span>:</span>{" "}
                  </li>
                  <li>
                    <input
                      type="text"
                      className="form-control width-150"
                      name="weft"
                      tabIndex="2"
                      value={fabric.count.weft}
                      onChange={e =>
                        this.props.updateCountConstruction(
                          e,
                          "count"
                        )
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        {/* SECTION 1 - RIGHT START */}
        <div class="col-xs-5 view-ib-right nopadding">
          <div class="ib-list-view listFieldWrapper nopadding">
            <ul class="main-list">
              {fabric.selectedType ===
                "development" ? (
                  <li>
                    <ul>
                      <li className="">
                        Dev Ref No
                                   </li>
                      <li className="">
                        {this.state.development !==
                          null &&
                          fabric.devRefNumber}
                      </li>
                      <li className="">
                        <b>Priority</b>
                      </li>
                      <li>
                        <Field
                          isFormGroup={false}
                          inputType="select"
                          inputName="priority"
                          value={fabric.priority}
                          options={priorityOptions}
                          onChange={
                            this.props.getFabricData
                          }
                          disabled={
                            this.state.disabled
                          }
                        />
                      </li>
                    </ul>
                  </li>
                ) : (
                  <li className="height-27" />
                )}

              {fabric.selectedType ===
                "development" ? (
                  <li>
                    <ul>
                      <Fragment>
                        <li className="text-right">
                          Magnum ETA
                                     </li>
                        <li>
                          <Field
                            isFormGroup={false}
                            inputType="date"
                            value={
                              fabric.magnumETADate
                                ? fabric.magnumETADate
                                : ""
                            }
                            inputName="magnumETADate"
                            onChange={
                              this.props
                                .getFabricData
                            }
                            disabled={
                              this.state.disabled
                            }
                          />
                        </li>
                      </Fragment>
                      <li class="">Supplier ETA</li>
                      <li>
                        <Field
                          isFormGroup={false}
                          inputType="date"
                          value={
                            fabric.supplierETADate
                          }
                          inputName="supplierETADate"
                          onChange={
                            this.props.getFabricData
                          }
                          disabled={
                            this.state.disabled
                          }
                        />
                      </li>
                    </ul>
                  </li>
                ) : (
                  <li className="height-27" />
                )}
              <li className="height-27" />
              <li className="print-hidden">
                <ul>
                  <li className="padding-for-li">
                    Construction
                                 </li>
                </ul>
              </li>
              <li className="print-hidden">
                <ul>
                  <li className="text-right">
                    Reed<span>:</span>{" "}
                  </li>
                  <li>
                    <input
                      type="text"
                      style={{ width: "150px" }}
                      className="form-control"
                      name="warp"
                      tabIndex="3"
                      value={
                        fabric.construction.warp
                      }
                      onChange={e =>
                        this.props.updateCountConstruction(
                          e,
                          "construction"
                        )
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                  <li className="text-right">
                    <b>Pick</b>
                    <span>:</span>{" "}
                  </li>
                  <li>
                    <input
                      type="text"
                      style={{ width: "150px" }}
                      className="form-control"
                      name="weft"
                      tabIndex="4"
                      value={
                        fabric.construction.weft
                      }
                      onChange={e =>
                        this.props.updateCountConstruction(
                          e,
                          "construction"
                        )
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-xs-12 nopadding">
          <div className="col-xs-3 nopadding text-right">
            <label>
              <b>Count & Construction</b>
            </label>
          </div>
          <div class="col-xs-6 nopadding px-3">
            <input
              type="text"
              className="form-control"
              name="countconstruction"
              readOnly
              value={countConstruction}
            />
          </div>
        </div>
        <div class="col-xs-5  view-ib-right nopadding">
          <div class="ib-list-view listFieldWrapper nopadding">
            <ul class="main-list">
              <li>
                <ul>
                  <li className="text-right" />
                  <li />
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Classification of fabric{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="classificationOfFabric"
                      value={
                        fabric.classificationOfFabric
                      }
                      options={
                        fabricInfo.CLASSIFICATIONOFFABRIC
                      }
                      
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Quality{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="quality"
                      value={fabric.quality}
                      options={
                        fabricInfo.BASICQUALITY
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Composition{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="composition"
                      value={fabric.composition}
                      options={
                        fabricInfo.COMPOSITION
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Requirement{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="requirement"
                      value={fabric.requirement}
                      options={
                        fabricInfo.REQUIREMENT
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>

              <li>
                <ul>
                  <li className="text-right">
                    Ref Fab No.{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="text"
                      inputName="refFabNo"
                      value={fabric.refFabNo}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Supplier Ref no
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="text"
                      inputName="supplierRefNo"
                      value={fabric.supplierRefNo}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    quantity received
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="text"
                      inputName="quantityReceived"
                      value={
                        fabric.quantityReceived
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>

              <li>
                <ul>
                  <li className="text-right">
                    Buyer primary light source
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="buyerPrimarySource"
                      value={
                        fabric.buyerPrimarySource
                      }
                      options={
                        fabricInfo.BUYERPRIMARYLIGHTSOURCE
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>

              <li>
                <ul>
                  <li className="text-right">
                  Base No{" "}
                  </li>
                  <li>
                  <Async
                      name="bNumber"
                      value={fabric.bNumber}
                      onInputChange={
                        this.getBnoDropdown
                      }
                      onChange={(value) => this.handleBaseNoDropdownChange("bNumber", value)}
                      placeholder="Find Base No"
                      options={dropDown1}
                      disabled={
                        this.state.disabled
                      }
                    />
                    {/* <Async
                      name="bNumber"
                      value={bnumberValue}
                      onInputChange={this.getBnumberInfo}
                      onChange={this.changeBnumberInfo}
                      placeholder="Find Bnumber"
                      options={bNumberInfo}
                      disabled={this.state.disabled}
                      isClearable={true}
                      onMenuClose={data => 
                    /> */}
                    {/* <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="bNumber"
                      value={
                        fabric.bNumber
                      }
                      options={
                        dropDown1.bNumbers
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    /> */}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        {/* SECTION 1 - LEFT  END */}

        <div class="col-xs-5 nopadding">
          <div class="ib-list-view listFieldWrapper">
            <ul class="main-list">
              <li>
                <ul>
                  <li className="text-right">
                    GSM/OZ
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="number"
                      inputName="gsm"
                      value={fabric.gsm}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                  <li className="text-right">
                    <b>width</b>
                  </li>
                  <li className="">
                    <Field
                      isFormGroup={false}
                      inputType="number"
                      inputName="width"
                      value={fabric.width}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Cust Design Ref no
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="text"
                      inputName="custDefNo"
                      value={fabric.custDefNo}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Color{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="text"
                      inputName="colorWay"
                      value={fabric.colorWay}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Origination of artwork
                                   <span>:</span>{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="orginationOfArtwork"
                      value={
                        fabric.orginationOfArtwork
                      }
                      options={
                        fabricInfo.ORIGINATIONOFARTWORK
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    {" "}
                    MAG 3D Ref No.<span>
                      :
                                   </span>{" "}
                  </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="text"
                      inputName="magCadRefNo"
                      value={fabric.magCadRefNo}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Customer-Dept{" "}
                  </li>
                  <li>
                    <select
                      className="form-control"
                      name="customerDepartmentId"
                      onChange={e =>
                        this.props.getFabricData(
                          e.target.name,
                          e.target.value
                        )
                      }
                      value={
                        fabric.customerDepartmentId
                      }
                      disabled={
                        this.state.disabled
                      }
                    >
                      <option value="">
                        select
                                     </option>
                      {customerList.map(data => {
                        return (
                          <option
                            value={
                              data.departmentId
                            }
                          >{`${
                            data.customerName
                            } - ${
                            data.departmentName
                            }`}</option>
                        );
                      })}
                    </select>
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    {" "}
                    MAG Style No.<span>
                      :
                                   </span>{" "}
                  </li>
                  <li>
                    <Async
                      name="magnumStyleId"
                      value={fabric.magnumStyleId}
                      onInputChange={
                        this.getStyleInfo
                      }
                      onChange={value =>
                        this.props.getSelectData(
                          "magnumStyleId",
                          value
                        )
                      }
                      placeholder="Find Style"
                      options={styleList}
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Attribute
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="attribute"
                      value={fabric.attribute}
                      options={
                        fabricInfo.ATTRIBUTE
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>

              <li>
                <ul>
                  <li className="text-right">
                    File Transfer
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="select"
                      inputName="fileTransfer"
                      value={fabric.fileTransfer}
                      options={
                        fabricInfo.FILETRANSFER
                      }
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
              <li>
                <ul>
                  <li className="text-right">
                    Print Fabric Price
                                 </li>
                  <li>
                    <Field
                      isFormGroup={false}
                      inputType="text"
                      inputName="printFabricPrice"
                      value={fabric.printFabricPrice}
                      onChange={
                        this.props.getFabricData
                      }
                      disabled={
                        this.state.disabled
                      }
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        {/* SECTION 1 RIGHT END */}
        <div class="col-md-12 py-0 px-5">
          <Field
            isFormGroup={true}
            inputType="textarea"
            inputName="specialComments"
            value={fabric.specialComments}
            label="special comments"
            onChange={this.props.getFabricData}
            disabled={this.state.disabled}
          />
        </div>
      </Fragment>
    );
  }
}

FabricMainSection.propTypes = {};

FabricMainSection.defaultProps = {};
export default FabricMainSection


// WEBPACK FOOTER //
// ./src/components/Fabric/FabricMainSection/FabricMainSection.js